<template>
  <div class="container">
    <div class="app">
      <head-info/>
      <project-history></project-history>
    </div>
  </div>
</template>

<script>
import HeadInfo from '../components/HeadInfo'
import ProjectHistory from '../components/ProjectHistory'

export default {
  name: 'Resume',
  components: {
    ProjectHistory,
    HeadInfo
  }
}
</script>

<style scoped>

</style>
